module.exports = __webpack_public_path__ + "static/img/ntropic1.4e2fd03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/ntropic1.jpg
// module id = TsXv
// module chunks = 1